<template>
  <div id="centerRight2">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <span class="text mx-2">设备分项能耗</span>
      </div>
      <div class="d-flex ai-center flex-column body-box">
        <dv-capsule-chart class="dv-cap-chart" :config="config" />
      </div>
    </div>
      <div class="down">
      <div class="ranking bg-color-black">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <span class=" text mx-2 mb-1 pl-3">科室当日耗汽排行</span>
        <dv-scroll-ranking-board class="dv-scr-rank-board mt-1" :config="ranking" />
      </div>
   
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      config: {
        data: [
          {
            name: '空调',
            value: 2150
          },
          {
            name: '照明',
            value: 479
          },
          {
            name: '医疗设备',
            value: 3246
          },
          {
            name: '办公设备',
            value: 870
          },
          {
            name: '其他设备',
            value: 364
          }
        ]
      },
       ranking: {
        data: [
          {
            name: '消化内科',
            value: 12
          },
          {
            name: '呼吸科',
            value: 15
          },
          {
            name: '普外科',
            value: 16
          },
          {
            name: '泌尿外科',
            value: 19
          },
          {
            name: '妇产科',
            value: 22
          },
          {
            name: '儿科',
            value: 9
          },
          {
            name: '肿瘤科',
            value: 11
          },
          {
            name: '烧伤科',
            value: 17
          },
          {
            name: '口腔科',
            value: 14
          },
          {
            name: '血液科',
            value: 18
          }
        ],
        carousel: 'single',
        unit: 'm³'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#centerRight2 {
  display: flex;
  flex-direction: column;
  $box-height: 210px;
  $box-width: 340px;
  padding: 5px;
 
  border-radius: 5px;
  .bg-color-black {
    padding: 5px;
    height: $box-height;
    width: $box-width;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-cap-chart {
      width: 100%;
      height: 160px;
    }
  }
   .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 150px;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 100%;
      .dv-scr-rank-board {
        height: 150px;
      }
    }

  }
}
</style>
